import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const Gold = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={39}
    height={38}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M38.282 22.556c0 .274 0 .634-2.385 3.676a137.06 137.06 0 0 1-2.281 2.81.581.581 0 0 1-.46.217c-.059 0-.118 0-.163-.03-.237-.071-.4-.258-.414-.49-.178-1.657-.445-3.747-.934-5.217a.52.52 0 0 1 .09-.505l3.436-4.655a.61.61 0 0 1 .504-.245c.193 0 .385.1.489.274.785 1.225 2.118 3.416 2.118 4.165Z"
      />
      <Path
        fill="url(#c)"
        d="M33.35 29.216s-.06.029-.208.029c-.03 0-.074 0-.104-.015-4.86-.821-9.318-2.09-13.244-3.762a.574.574 0 0 1-.163-.951l4.06-3.777a.616.616 0 0 1 .607-.13l.237.073c2.977.994 6.622 3.228 7.91 3.142l.904 5.39Z"
      />
      <Path
        fill="#A5CDFF"
        d="m36.12 19.01-3.438 4.656a.603.603 0 0 1-.444.245h-.193c-1.6 0-4.651-1.023-7.896-2.119l-.237-.086a.61.61 0 0 1-.385-.418.52.52 0 0 1 .178-.534l4.8-4.454a.592.592 0 0 1 .533-.144c3.289.663 5.718 1.269 6.933 2.033a.582.582 0 0 1 .267.374.607.607 0 0 1-.119.447Z"
      />
      <Path
        fill="url(#d)"
        d="m30.4 16.128-9.955 9.24-.014.014-9.26 7.812a.634.634 0 0 1-.385.144c-.059 0-.103 0-.163-.029a.604.604 0 0 1-.4-.375c-.814-2.508-1.155-4.381-1.066-5.91 0-.143.074-.273.178-.374 5.451-5.232 9.362-8.418 13.525-11.776a334.277 334.277 0 0 0 3.482-2.84.6.6 0 0 1 .577-.1c1.793.605 2.756 2.132 3.6 3.487a.582.582 0 0 1-.118.707Z"
      />
      <Path
        fill="url(#e)"
        d="M4.076 17.511c-.045 0-.09 0-.134-.014l-3.126-.72c-.31-.073-.518-.39-.444-.693a.604.604 0 0 1 .711-.432l3.126.72c.311.073.518.39.444.692a.57.57 0 0 1-.577.447Z"
      />
      <Path
        fill="url(#f)"
        d="M10.609 11.184a.562.562 0 0 1-.49-.26L8.343 8.315a.567.567 0 0 1 .163-.792.603.603 0 0 1 .815.158l1.763 2.609c.178.26.103.62-.163.793a.502.502 0 0 1-.311.1Z"
      />
      <Path
        fill="url(#g)"
        d="M30.786 11.458a.746.746 0 0 1-.296-.072.562.562 0 0 1-.223-.779l1.57-2.724a.595.595 0 0 1 .8-.216.562.562 0 0 1 .223.778l-1.57 2.724a.564.564 0 0 1-.504.289Z"
      />
      <Path
        fill="url(#h)"
        d="M26.401 9.281c-.03 0-.074 0-.119-.014a.578.578 0 0 1-.474-.678l.593-3.07a.592.592 0 0 1 .696-.461c.326.057.534.36.474.677l-.592 3.07a.57.57 0 0 1-.578.476Z"
      />
      <Path
        fill="url(#i)"
        d="M33.645 14.73a.624.624 0 0 1-.474-.231.567.567 0 0 1 .133-.807l2.593-1.845a.604.604 0 0 1 .83.13c.192.259.133.62-.134.807l-2.592 1.845a.83.83 0 0 1-.356.1Z"
      />
      <Path
        fill="url(#j)"
        d="M6.165 13.505a.69.69 0 0 1-.356-.116l-2.578-1.83a.567.567 0 0 1-.133-.807.604.604 0 0 1 .83-.13l2.577 1.83a.567.567 0 0 1 .134.807.596.596 0 0 1-.474.245Z"
      />
      <Path
        fill="url(#k)"
        d="M10.786 33.338a.588.588 0 0 1-.34-.1c-2.178-1.514-7.274-5.118-7.733-5.997-.563-1.067-.06-3.704.31-4.814a.56.56 0 0 1 .386-.36.588.588 0 0 1 .533.086l6.148 4.44c.163.115-.252.835-.267 1.037-.088 1.384.963 5.708.963 5.708Z"
      />
      <Path
        fill="#A5CDFF"
        d="M27.082 12.899c-1.2.995-2.355 1.932-3.466 2.84-4.133 3.358-8.044 6.515-13.467 11.718a.593.593 0 0 1-.414.173.65.65 0 0 1-.356-.115l-6.148-4.44a.523.523 0 0 1-.237-.432.554.554 0 0 1 .193-.461c.044-.03 3.837-3.359 7.762-6.645 8.09-6.775 8.756-6.775 9.156-6.775 1.452 0 6 2.667 6.903 3.2.163.101.267.26.282.447a.548.548 0 0 1-.208.49Z"
      />
    </G>
    <Defs>
      <RadialGradient
        id="e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(148.181 -.834 8.335) scale(3.12644 3.16767)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(118.696 2.64 6.88) scale(3.76567 3.58698)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(116.465 13.4 13.862) scale(3.79869 3.42736)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(106.44 11.343 12.8) scale(3.88204 2.38318)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-2.3301 2.6324 -2.95468 -2.61537 35.247 12.088)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="j"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-2.321 2.63238 -2.95322 -2.6039 5.165 10.863)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <LinearGradient
        id="b"
        x1={37.312}
        x2={30.343}
        y1={17.233}
        y2={25.066}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9BC7FE" />
        <Stop offset={1} stopColor="#378CF7" />
      </LinearGradient>
      <LinearGradient
        id="c"
        x1={31.325}
        x2={28.064}
        y1={19.892}
        y2={29.724}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9BC7FE" />
        <Stop offset={1} stopColor="#378CF7" />
      </LinearGradient>
      <LinearGradient
        id="d"
        x1={27.467}
        x2={16.269}
        y1={10.198}
        y2={31.241}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9BC7FE" />
        <Stop offset={1} stopColor="#378CF7" />
      </LinearGradient>
      <LinearGradient
        id="k"
        x1={9.575}
        x2={2.818}
        y1={21.141}
        y2={30.493}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9BC7FE" />
        <Stop offset={1} stopColor="#378CF7" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M.357.748h37.925v36.9H.357z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default Gold
